import { FunctionComponent, useState } from "react"
import { Button, FormControl, Modal, TextField } from "@mui/material"
import ContainerModal from "../../../../components/modalExportar/components/containerModal"
import useNav from "../../../../hooks/useNav"
import { useForm } from "react-hook-form"


export const GrupoSedeAdd: FunctionComponent = () => {

  const { goBack, navTo } = useNav();

  const {
    register
  } = useForm<{ descricao: string }>({
    defaultValues: {
      descricao: null
    }
  });

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <FormControl fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained">Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}

